<template>
  <v-navigation-drawer
      v-if="$store.state.loggedin"
      fixed
      clipped
      overlap
      v-model="drawer"
      app>
      <div>
        <v-list class="pa-0" style="position: relative">
            <v-list-item>
                <v-list-item-avatar>
                    <img v-if="$store.state.loggedin && $store.state.user.img" :src="$store.state.user.img">
                    <v-icon v-else>face</v-icon>
                </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title fluid>
                  {{ username }}<br/>
                  <span v-if="org" class="caption">{{org.name}}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list shaped>
            <v-list-item-group v-model="nav_selection" mandatory>
            <v-list-item v-for="nav in nav_data" :key="nav.tag" v-can="nav.filter" :to="nav.link+getParams(nav)" :value="nav.tag" @click="resetSearchHistory">
                  <v-list-item-icon><v-icon>{{nav.icon}}</v-icon></v-list-item-icon>
                  <v-list-item-title>{{nav.label}}</v-list-item-title>
            </v-list-item>
            <v-list-item  v-if="!isProduction" to="/mysandbox">
                <v-list-item-action>
                <v-icon>build</v-icon>
                </v-list-item-action>
                <v-list-item-title>Sandbox</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="!isProduction" to="/ffsandbox">
                <v-list-item-action>
                <v-icon>build</v-icon>
                </v-list-item-action>
                <v-list-item-title>Sandbox/FF -> datalogger</v-list-item-title>
            </v-list-item>

            
            <v-list-group
                no-action
                prepend-icon="receipt"
                >
                <template v-slot:activator>
                    <v-list-item-title>Report</v-list-item-title>
                </template>
                <!--v-list-item to="/reports/list" @click="resetSearchHistory">
                    <v-list-item-action>
                    <v-icon>receipt</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>lista</v-list-item-title>
                </v-list-item>
                <v-list-item to="/reports/reviews" @click="resetSearchHistory">
                    <v-list-item-action>
                    <v-icon>rate_review</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>riesame</v-list-item-title>
                </v-list-item>
                <v-list-item to="/reports/pdf_gen" @click="resetSearchHistory">
                    <v-list-item-action>
                    <v-icon>picture_as_pdf</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>generazione pdf</v-list-item-title>
                </v-list-item-->
                 <v-list-item v-for="nav in nav_report" :key="nav.tag" v-can="nav.filter" :to="nav.link" :value="nav.tag" @click="resetSearchHistory">
                    <v-list-item-icon><v-icon>{{nav.icon}}</v-icon></v-list-item-icon>
                    <v-list-item-title>{{nav.label}}</v-list-item-title>
                    
                </v-list-item>
            </v-list-group>
            <v-list-group
                no-action
                prepend-icon="settings"
                >
                <template v-slot:activator>
                    <v-list-item-title>Impostazioni</v-list-item-title>
                </template>
                <v-list-item v-for="nav in nav_admin" :key="nav.name" v-can="nav.filter" :to="nav.link+getParams(nav)" :value="nav.tag" @click="resetSearchHistory">
                    <v-list-item-icon><v-icon>{{nav.icon}}</v-icon></v-list-item-icon>
                    <v-list-item-title>{{nav.label}}</v-list-item-title>
                </v-list-item>
                
            </v-list-group>
            </v-list-item-group>
        </v-list>
      </div>
  </v-navigation-drawer>
</template>
<script>
export default {
    name: 'navigation',
    props: ['toggle'],
    data(){        
        return {
            drawer: true,

            organism: {},
            nav_selection: 'home',
            nav_adm_selection: null,
            nav_data: [
                {'icon':"home" , 'link': "/home", 'label': "Home" ,'tag': 'home'},
                {'icon':"people" , 'link': "/clients/", 'label': "Clienti" ,'tag': 'clients'},
                {'icon': "build" , 'link': "/instruments/" , 'label': "Strumenti",'tag': 'instruments'},
                {'icon': "access_time", 'link': "/operations/", 'label': "Interventi",'tag': "operations"}
            ],
            nav_admin: [
                // {'icon': "sync_problem" , 'link': "/manageDb" , 'label': "Sincro dati",'tag': 'admin.manageDb'},
                {'icon': "cached" , 'link': "/idempiereSynchro" , 'label': "Sincro Idempiere",'tag': 'admin.idempiereSynchro', 'filter': {obj_type:'synchro', action: 'view'}},
                {'icon': "swap_vert" , 'link': "/mastercalSynchro" , 'label': "Sincro Mastercal",'tag': 'admin.mastercalSynchro', 'filter': {obj_type:'synchro', action: 'view'}},
                {'icon':"account_box" , 'link': "/admin/users", 'label': "Utenti" ,'tag': 'admin.users', 'filter': {obj_type:'user', action: 'list'}},
                {'icon':"tune" , 'link': "/admin/config", 'label': "Configurazione" ,'tag': 'admin.config','filter': {obj_type:'config', action: 'view'}},
                {'icon': "assistant_direction" , 'link': "/admin/master/" , 'label': "Master",'tag': 'admin.masters'},
                {'icon': "dataset" , 'link': "/admin/category/" , 'label': "Set di prove",'tag': 'admin.categories'},
                {'icon': "assignment" , 'link': "/admin/procedure/" , 'label': "Procedure",'tag': 'admin.procedures'},
                {'icon': "calculate", 'link': "/admin/formulas", 'label': "Formule", 'tag': 'admin.formulas', 'filter': {obj_type:'formulas', action: 'view'}},
                {'icon': "groups", 'link': "/admin/orgs", 'label': "Enti",'tag': "admin.organisms", 'filter': {obj_type:'organism', action: 'list'}},
                {'icon': "assignment", 'link':  `/admin/orgs/details`, 'params': {'org_id': this.$store.state.user.org_id}, 'label': "Ente",'tag': "user.organism", 'filter': {obj_type:'organism', action: 'view_org'}},
                {'icon': "category" , 'link': "/admin/primaries" , 'label': "Masse di lavoro",'tag': 'admin.primaries'}
            ],
            nav_report: [
                {'icon':"av_timer" , 'link': "/reports/new", 'label': "in corso" ,'tag': 'report.new'},
                {'icon':"rate_review", 'link': "/reports/reviews", 'label': "in attesa di riesame" ,'tag': 'report.review', 'filter': {obj_type:'review', action: 'list'}},
                {'icon':"warning" , 'link': "/reports/revising", 'label': "riesame fallito" ,'tag': 'report.revising'},
                {'icon': "exit_to_app" , 'link': "/reports/pdf_gen" , 'label': "generazione PDF",'tag': 'report.pdf_gen', 'filter': {obj_type:'pdf_generation', action: 'list'}},
                {'icon': "picture_as_pdf" , 'link': "/reports/ready" , 'label': "completati",'tag': 'report.ready'},
                {'icon': "verified" , 'link': "/reports/signed" , 'label': "firmati",'tag': 'report.signed'},
                {'icon': "assignment" , 'link': "/reports/report_management" , 'label': "gestione",'tag': 'admin.report_management', 'filter': {obj_type:'report_management', action: 'list'}},
            ],
            org: null
        }
    },
    watch: {
        toggle() {
            this.drawer = !this.drawer;
        },
        "$store.state.loggedin": {
            async handler() {
                if (this.$store.state.loggedin) {
                    await this.getOrg()
                } else {
                    this.org = null
                }
            }
        }
    },
    computed: {
        username(){
            if(this.$store.state.loggedin){
                console.log("DEBUG: user", this.$store.state.user)
                return this.$store.state.user.name
            } else {
                return "Username"
            }
        },
        isProduction() {
            // return process.env.NODE_ENV === "production"
            return true
        },
        orgName(){
            if(this.$store.state.loggedin){
                return this.org.name ? this.org.name : ""
            } else {
                return "not logged"
            }
        },
        orgId(){
            console.log('********', this.$store.state.user.org_id)
            if(this.$store.state.loggedin){
                return this.$store.state.user.org_id
            } else {
                return ""
            }
        },
	},
	async mounted() {
		await this.getOrg()
    },
    methods: {
        resetSearchHistory() {
            this.$store.commit('setSearchParam', { resetAll: true})
        },
        async getOrg() {
            if(this.$store.state.loggedin){
                let user = this.$store.state.user
                this.organism = {
                    name: "orgDetails",
                    query: {org_id: user.org_id}
                }
                this.org = await this.$store.state.$pouch.get("registry", user.org_id)
            } else {
                this.org = null
            }  
        },
        getParams(nav) {
            if (nav.params) {
                return '?'+Object.keys(nav.params).map(key => key + '=' + nav.params[key]).join('&');
            } else {
                return ''
            }
        }
    }
}
</script>